import React, { useEffect, useRef } from 'react';

const AdBanner = ({ adKey, width, height, instanceId }) => {
  const adContainerRef = useRef(null);

  useEffect(() => {
    const currentRef = adContainerRef.current;
    
    // 1. Define the options
    const atOptions = {
      'key': adKey,
      'format': 'iframe',
      'height': height,
      'width': width,
      'params': {}
    };

    // 2. Set the global variable
    window.atOptions = atOptions;

    // 3. Create the script using your specific URL
    const script = document.createElement('script');
    script.src = `https://annoyingnightmareedit.com/${adKey}/invoke.js`;
    script.type = "text/javascript";
    script.async = true;

    if (currentRef) {
      currentRef.innerHTML = ''; // Clear container
      currentRef.appendChild(script);
    }

    return () => {
      if (currentRef) {
        currentRef.innerHTML = '';
      }
    };
  }, [adKey, width, height, instanceId]); // instanceId ensures unique runs

  return (
    <div 
      className="ad-container" 
      style={{ minHeight: height, width: width, display: 'inline-block' }}
    >
      <div ref={adContainerRef}></div>
    </div>
  );
};

export default AdBanner;